import React from 'react';
import { Button, Flex } from '@cognite/cogs.js';
import { DrawerWithTitle } from 'pages/ViewDigitalTwinPage/components/Schemas/ViewSchemaPage/ProjectRuleset/components/DrawerWithTitle';
import { DrawerSteps } from 'components/DrawerSteps/DrawerSteps';
import { DigitalTwin } from 'types/graphql-apollo-v2';
import { ConsistencySchemaFilterView } from '../types';
import { useEditSchemaFilterDrawer } from './useEditSchemaFilterDrawer';
import { buildSchemaFilterSteps } from '../NewConsistencySchemaFilterDrawer.steps';

type EditSchemaFilterDrawerProps = {
  visible: boolean;
  onClose: VoidFunction;
  schemaFilter: ConsistencySchemaFilterView | undefined;
  onSchemaFilterUpdated: (
    id: string,
    params: {
      name: string;
      description: string;
      labels: string[];
      schemaType: string;
      schemaCollectionId: string;
      filters: string;
    }
  ) => Promise<void>;
  digitalTwin: DigitalTwin;
};

export const EditSchemaFilterDrawer = ({
  visible,
  onClose,
  schemaFilter,
  onSchemaFilterUpdated,
  digitalTwin,
}: EditSchemaFilterDrawerProps) => {
  const hookResult = useEditSchemaFilterDrawer({
    schemaFilter,
    visible,
    onClose,
    onSchemaFilterUpdated,
    digitalTwin,
  });

  const {
    currentStep,
    setCurrentStep,
    creating,
    handleSubmit,
    hasInvalidValues,
  } = hookResult;

  const steps = buildSchemaFilterSteps(hookResult);

  return (
    <DrawerWithTitle
      title="Edit Schema Filter"
      visible={visible}
      onCancel={onClose}
      footer={
        <Flex justifyContent="flex-end" alignItems="center" gap={8}>
          <Button onClick={onClose} disabled={creating}>
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={() => void handleSubmit()}
            loading={creating}
            disabled={creating || hasInvalidValues}
          >
            Save
          </Button>
        </Flex>
      }
    >
      <DrawerSteps
        steps={steps}
        currentStep={currentStep}
        onChangeStep={(step: number) => setCurrentStep(step)}
      />
    </DrawerWithTitle>
  );
};
